import React from "react"
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import StripeForm from "./StripeForm"

const StripeElement = ({
  public_key,
  paymentOption,
  setPaymentOption,
  payment_intent,
  clientSecret,
  handleCreateIntent,
  setTransactionID,
  transactionID,
  setLoadingPayment,
  submitLoading,
  setSubmitLoading,
  handleComplete,
  apiTag,
  extraCharges,
  formData
}) => {
  const stripePromise = loadStripe(public_key)

  return (
    <Elements stripe={stripePromise}>
      <StripeForm
        payment_intent={payment_intent}
        clientSecret={clientSecret}
        handleCreateIntent={handleCreateIntent}
        transactionID={transactionID}
        setTransactionID={setTransactionID}
        setLoadingPayment={setLoadingPayment}
        setSubmitLoading={setSubmitLoading}
        submitLoading={submitLoading}
        handleComplete={handleComplete}
        paymentOption={paymentOption}
        setPaymentOption={setPaymentOption}
        extraCharges={extraCharges}
        apiTag={apiTag}
        formData={formData}
      />
    </Elements>
  )
}

export default StripeElement
